/* STEP 5 — Review & Commit. Summarises the upload (account code, prozoId, scope,
   effective date, attached files), then commits → real uploadServicabilityFile
   calls (handled by the parent's finish()). */
import React from 'react'
import PropTypes from 'prop-types'
import CheckIcon from '@mui/icons-material/Check'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import {KpiStrip, fmtDate, useToast} from '../components'

/* download an attached File object (the CSV the user uploaded / the editor generated) */
function downloadFile(file) {
  const url = URL.createObjectURL(file)
  const a = document.createElement('a')
  a.href = url
  a.download = file.name || 'download.csv'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export default function StepReview({U, onSetReview, onBack, onCommit, busy}) {
  const toast = useToast()
  const R = U.review || {}

  const kpis = [
    {label: 'Account code', value: U.display || U.code, icon: <LocalShippingOutlinedIcon fontSize='small' />, sub: U.partnerName},
  ]
  if (U.scope.rates)
    kpis.push({label: 'Rate card', value: U.rateFile ? '1 file' : '—', icon: <PaymentsOutlinedIcon fontSize='small' />, sub: 'WEIGHT_PRICE'})
  if (U.scope.tat)
    kpis.push({label: 'TAT', value: U.tatFile ? '1 file' : '—', icon: <ScheduleOutlinedIcon fontSize='small' />, sub: 'applied immediately'})
  if (U.scope.rates)
    kpis.push({label: 'Effective from', value: fmtDate(U.effectiveFrom), icon: <EventOutlinedIcon fontSize='small' />})

  const files = []
  if (U.scope.rates && U.rateFile) files.push({type: 'Rate card (WEIGHT_PRICE)', file: U.rateFile})
  if (U.scope.tat && U.tatFile) files.push({type: 'TAT', file: U.tatFile})

  return (
    <div>
      <KpiStrip className='fit150' cards={kpis} />

      <div className='card card-pad'>
        <div className='seclabel' style={{marginBottom: 10}}>Files to upload</div>
        {files.length ? (
          files.map((f) => (
            <div className='fileitem' style={{marginTop: 0, marginBottom: 8}} key={f.type}>
              <span className='ic'>
                <InsertDriveFileOutlinedIcon fontSize='small' />
              </span>
              <div style={{flex: 1}}>
                <div style={{fontWeight: 600}}>{f.file.name}</div>
                <div className='hlp'>
                  {f.type} · uploaded to <span className='mono'>{U.prozoId}</span>
                  {f.type.startsWith('Rate') ? ` · effective ${fmtDate(U.effectiveFrom)}` : ''}
                </div>
              </div>
              <button type='button' className='btn btn-sm' onClick={() => downloadFile(f.file)}>
                <DownloadOutlinedIcon style={{width: 14, height: 14}} />
                Download
              </button>
            </div>
          ))
        ) : (
          <div className='muted' style={{fontSize: 12.5}}>No files attached — go back and upload at least one.</div>
        )}

        <label
          className='checkrow optcard'
          style={{marginTop: 8, cursor: 'pointer', fontSize: 13, padding: '11px 13px', border: '1px solid var(--border)', borderRadius: 8, alignItems: 'flex-start'}}
        >
          <input
            type='checkbox'
            checked={!!R.reviewed}
            onChange={(e) => onSetReview({reviewed: e.target.checked})}
            style={{marginTop: 2}}
          />
          I’ve reviewed the file(s) above and confirm they’re correct for{' '}
          <b>{U.display || U.code}</b>.
        </label>
      </div>

      <div className='row gap12' style={{display: 'flex', gap: 12, marginTop: 20, justifyContent: 'flex-end'}}>
        <button type='button' className='btn' onClick={onBack} disabled={busy}>
          <ArrowBackIcon style={{width: 16, height: 16}} />
          Back
        </button>
        <button
          type='button'
          className='btn btn-primary'
          disabled={busy || !R.reviewed || !files.length}
          onClick={() => {
            if (!R.reviewed || !files.length) {
              toast('Attach a file and confirm your review before committing.', 'error')
              return
            }
            onCommit()
          }}
        >
          <CheckIcon style={{width: 16, height: 16}} />
          {busy ? 'Uploading…' : 'Commit to ProShip'}
        </button>
      </div>
    </div>
  )
}

StepReview.propTypes = {
  U: PropTypes.object,
  onSetReview: PropTypes.func,
  onBack: PropTypes.func,
  onCommit: PropTypes.func,
  busy: PropTypes.bool,
}
